import { useCallback, useState } from "react";
import { AnimatePresence } from "framer-motion";
import { Preloader } from "@/components/site/Preloader";
import { Vessels } from "@/components/home/Vessels";
import { OceanVision } from "@/components/home/OceanVision";
import { Hero } from "@/components/home/Hero";
import { WhyUnmanned } from "@/components/home/WhyUnmanned";
import { Transformation } from "@/components/home/Transformation";
import { Principles } from "@/components/home/Principles";
import { Demos } from "@/components/home/Demos";
import { Collaborators } from "@/components/home/Collaborators";
import { Founders } from "@/components/home/Founders";
import { LogbookSection } from "@/components/home/LogbookSection";
import { ActionRows } from "@/components/home/ActionRows";

const INTRO_KEY = "x1025-intro-seen";

export default function Home() {
  const [ready, setReady] = useState(() => {
    try {
      return sessionStorage.getItem(INTRO_KEY) === "1" || window.location.hash !== "";
    } catch (e) {
      return true;
    }
  });
  const finish = useCallback(() => {
    try {
      sessionStorage.setItem(INTRO_KEY, "1");
    } catch (e) {
      /* storage unavailable */
    }
    setReady(true);
  }, []);

  return (
    <div data-testid="home-page">
      <AnimatePresence>{!ready && <Preloader onDone={finish} />}</AnimatePresence>
      <Hero ready={ready} />
      <Transformation />
      <WhyUnmanned />
      <Vessels />
      <Principles />
      <Demos />
      <Collaborators />
      <Founders />
      <LogbookSection />
      <ActionRows />
      <OceanVision />
    </div>
  );
}
